import React from "react";
import { motion } from "framer-motion";
 
const Disclaimer = ({ onAccept }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-50 px-4">
      {/* Modal Container with Animation */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col max-h-[90vh]"
      >
        {/* Header */}
        <div className="p-4 border-b text-center sticky top-0 bg-white rounded-t-2xl z-10">
          <h2 className="text-lg md:text-xl font-bold text-gray-800">⚠️ DISCLAIMER</h2>
        </div>
 
        {/* Content (scrollable) */}
        <div className="px-6 py-4 overflow-y-auto text-sm md:text-sm text-gray-700 space-y-4">
          <p className="font-semibold text-gray-800 text-center">
            Important Notice – Beware of Fraudulent Emails, Calls, and Messages
          </p>
 
          <p>
            We, Japfa Comfeed India Private Limited (“the Company”) hereby inform you through this Notice that:
          </p>
 
          <p>
            It has come to our attention that unknown individuals are misusing the name, logo, and identity of <b>Japfa
            Comfeed India Pvt. Ltd. (“Japfa”)</b> to send fraudulent emails, phone calls, WhatsApp messages, and social media communications. 
Such persons may falsely claim to represent our company and may solicit donations, 
ask for money transfers, or other benefits.
 These communications misrepresent that the holder is authorised by Japfa to solicit or accept funds under so-called “investment schemes” 
or “deposit arrangements” promising returns

 </p>
 <p><b>Please note:</b></p>
          <ul className="list-decimal pl-6 space-y-2">
            <li>Japfa does not operate, endorse, or offer any investment schemes or avenues promising returns.</li>
            <li>
              Japfa does not request payments, donations, or confidential personal information through unofficial emails,
 personal Gmail/Yahoo accounts, messaging apps (such as WhatsApp or Telegram), or phone calls.
            </li>
            <li>Japfa has not authorised any person or entity to collect or accept monies on its behalf directly or indirectly.</li>
            <li>Japfa is not responsible for any loss, damage, or consequences arising from such fraudulent activities.
 Any such communication should be treated as suspicious.</li>
            <li>
              If you receive such messages, please do not respond or make any payments. Immediately report the matter to Japfa at{" "}
              <a href="mailto:Vidyasagar.a@japfa.com" className="text-blue-600 underline">
                Vidyasagar.a@japfa.com
              </a>{" "}
              and to the local police/ crime authorities.
            </li>
          </ul>
 
          <p>
           <b>Our company disclaims any responsibility for unauthorized representations made by third parties.</b>
          </p>
        </div>
 
        {/* Footer Button */}
        <div className="p-4 border-t bg-gray-50 sticky bottom-0 rounded-b-2xl">
          <button
            onClick={onAccept}
            className="w-full bg-blue-600 text-white font-semibold py-2.5 rounded-xl hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </motion.div>
    </div>
  );
};
 
export default Disclaimer;
